import React, { useState } from 'react'
import { IconButton } from '@mui/material'
import { Link } from 'react-router-dom'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import LocalAtmIcon from '@mui/icons-material/LocalAtm'
import ListAltIcon from '@mui/icons-material/ListAlt'
import FlutterDashIcon from '@mui/icons-material/FlutterDash'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import AddIcon from '@mui/icons-material/Add'
import { useAuth } from "../api/authStore"
import { loginUrl } from '../config/config'
import PaymentDialog from '../PaymentDialog'
import ThemeToggle from './ThemeToggle'
import HelpModal from './HelpModal'
import logo from '../img/landing-logo.png'

const MobileMenu = ({ user, active, apiClient, isOpen, onClose }) => {
  const { logout } = useAuth()
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false)
  const [showHelpModal, setShowHelpModal] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)
  const [shouldRender, setShouldRender] = useState(false)
  
  const accountEmail = user?.username || ''
  const balance = user?.balance ? (user.balance/100).toFixed(2) : '0.00'
  const activeProxiesCount = active?.rentals?.length || 0

  // Логирование только в режиме разработки
  React.useEffect(() => {
    if (user?.username && process.env.NODE_ENV === 'development') {
    }
  }, [user?.username])

  // Управление анимациями открытия/закрытия
  React.useEffect(() => {
    if (isOpen) {
      setShouldRender(true)
      setIsAnimating(true)
    } else {
      setIsAnimating(false)
      const timer = setTimeout(() => {
        setShouldRender(false)
      }, 300) // Время анимации закрытия
      return () => clearTimeout(timer)
    }
  }, [isOpen])

  const handleLogout = (e) => {
    if (e) {
      e.preventDefault()
    }
    logout(loginUrl)
  }

  const handleOpenPaymentDialog = () => {
    setOpenPaymentDialog(true)
  }

  const handleHelpClick = (e) => {
    if (e) {
      e.preventDefault()
    }
    setShowHelpModal(true)
  }

  if (!shouldRender) return null

  return (
    <>
      <div 
        className={`mobile-menu-backdrop-${isAnimating ? 'enter' : 'exit'}`}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1000
        }}
        onClick={onClose}
      />
      
      <div 
        className={`mobile-menu left-side-menu mobile-menu-${isAnimating ? 'enter' : 'exit'}`}
        style={{
          opacity: showHelpModal ? 0.3 : 1,
          transition: 'opacity 0.3s ease'
        }}>
        {/* Заголовок */}
        <div className="left-side-menu__header">
          <h1 className="left-side-menu__brand">
            {process.env.REACT_APP_NAME}
          </h1>
          <IconButton
            onClick={onClose}
            sx={{
              color: 'var(--sidebar-text-bright)',
              padding: '4px'
            }}
          >
            <ArrowBackIosNewOutlinedIcon fontSize="medium" />
          </IconButton>
        </div>

        {/* Профиль пользователя */}
        <div className="left-side-menu__profile">
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 'var(--spacing-sm)'
          }}>
            <div
              role="img"
              aria-label="XSocks Logo"
              className="left-side-menu__avatar-glow"
              style={{
                width: '32px',
                height: '32px',
                marginRight: 'var(--spacing-sm)',
                flexShrink: 0,
                background: 'var(--gradient-orange)',
                WebkitMaskImage: `url(${logo})`,
                maskImage: `url(${logo})`,
                WebkitMaskRepeat: 'no-repeat',
                maskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                maskPosition: 'center',
                WebkitMaskSize: 'contain',
                maskSize: 'contain'
              }}
            />
            <div style={{ flex: 1 }}>
              <div className="left-side-menu__email">
                <Link 
                  to='/account' 
                  style={{
                    cursor: 'pointer',
                    transition: 'color 0.2s ease',
                    display: 'inline-block'
                  }}
                  onClick={onClose}
                >
                  {accountEmail.replace(/(.{15})..+/, "$1…")}
                </Link>
              </div>
              <div className="left-side-menu__balance">
                <span className="left-side-menu__balance-label">
                  Balance: <strong className="left-side-menu__balance-value">${balance}</strong>
                </span>
                <button
                  onClick={handleOpenPaymentDialog}
                  title="Add Funds"
                  aria-label="Add Funds"
                  style={{
                    width: '22px',
                    height: '22px',
                    borderRadius: '50%',
                    background: 'var(--gradient-orange)',
                    border: 'none',
                    padding: 0,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    flexShrink: 0
                  }}
                >
                  <AddIcon style={{ fontSize: '14px', color: '#1a1a1a' }} />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Навигационное меню */}
        <div style={{ flex: 1, padding: 'var(--spacing-md) 0' }}>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.1s' }}>
            <MobileNavItem 
              icon={LocalGasStationIcon} 
              label="Proxies Store" 
              href="/proxies"
            />
          </div>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.15s' }}>
            <MobileNavItem 
              icon={FlutterDashIcon} 
              label={`Active Proxies${activeProxiesCount > 0 ? ` (${activeProxiesCount})` : ''}`} 
              href="/active"
            />
          </div>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.2s' }}>
            <MobileNavItem 
              icon={LocalAtmIcon} 
              label="Transactions" 
              href="/transactions"
            />
          </div>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.25s' }}>
            <MobileNavItem 
              icon={AccessTimeIcon} 
              label="History" 
              href="/history"
            />
          </div>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.3s' }}>
            <MobileNavItem 
              icon={ListAltIcon} 
              label="Tickets" 
              href="/tickets"
            />
          </div>
        </div>

        {/* Нижняя секция */}
        <div className="left-side-menu__footer">
          {/* Переключатель тем */}
          <div className="mobile-menu-item-enter" style={{ 
            animationDelay: '0.35s',
            marginBottom: 'var(--spacing-sm)'
          }}>
            <ThemeToggle />
          </div>
          
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.4s' }}>
            <MobileNavItem 
              icon={PsychologyAltIcon} 
              label="Help" 
              href="#"
              onClick={handleHelpClick}
            />
          </div>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.45s' }}>
            <MobileNavItem 
              icon={PowerSettingsNewIcon} 
              label="Logout" 
              href="#"
              onClick={handleLogout}
            />
          </div>
        </div>
      </div>

      <PaymentDialog 
        open={openPaymentDialog} 
        setOpentPaymentDialog={setOpenPaymentDialog} 
        apiClient={apiClient}
      />
      
      <HelpModal 
        isOpen={showHelpModal} 
        onClose={() => {
          setShowHelpModal(false)
        }}
        zIndex={10002}
      />
    </>
  )
}

const MobileNavItem = ({ icon: Icon, label, href, onClick }) => {
  const isActive = !onClick && href && typeof window !== 'undefined' && window.location.pathname === href

  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault()
      onClick(e)
    }
  }

  const handleTouchStart = (e) => {
    // Предотвращаем выделение текста
    e.preventDefault()
    // Добавляем визуальную обратную связь при touch
    e.target.style.backgroundColor = 'var(--sidebar-hover-bg)'
    e.target.style.color = 'var(--sidebar-active-text)'
    e.target.style.transform = 'scale(0.98)'
  }

  const handleTouchEnd = (e) => {
    // Убираем визуальную обратную связь после touch
    setTimeout(() => {
      e.target.style.backgroundColor = 'transparent'
      e.target.style.color = 'var(--sidebar-text-muted)'
      e.target.style.transform = 'scale(1)'
    }, 150)
  }

  const handleTouchCancel = (e) => {
    e.target.style.backgroundColor = 'transparent'
    e.target.style.color = 'var(--sidebar-text-muted)'
    e.target.style.transform = 'scale(1)'
  }

  return (
    <a 
      href={href} 
      onClick={handleClick}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={handleTouchCancel}
      className={`mobile-nav-item${isActive ? ' gold-gradient-border' : ''}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: 'var(--spacing-md) var(--spacing-lg)',
        margin: 'var(--spacing-xs) var(--spacing-sm)',
        borderRadius: 'var(--radius-md)',
        color: 'var(--sidebar-text-muted)',
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        backgroundColor: 'transparent',
        transform: 'scale(1)',
        position: 'relative'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--sidebar-hover-bg)'
        e.currentTarget.style.color = 'var(--sidebar-active-text)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent'
        e.currentTarget.style.color = 'var(--sidebar-text-muted)'
      }}
    >
      <Icon style={{ 
        fontSize: '20px', 
        marginRight: 'var(--spacing-md)',
        fill: 'url(#sidebarGoldGradient)'
      }} />
      <span style={{
        fontSize: 'var(--text-sm)',
        fontWeight: isActive ? '600' : '500',
        ...(isActive ? {
          background: 'var(--gradient-orange)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        } : {})
      }}>
        {label}
      </span>
    </a>
  )
}

export default MobileMenu

